import type { YmmField } from '../api/types';

// Action Types
export type YmmFormAction =
  | { type: 'SET_LOADING'; field: 'year' | 'make' | 'model'; isLoading: boolean }
  | { type: 'SET_ERROR'; error: string | null }
  | { type: 'SET_FIELDS'; fields: YmmField[] }
  | { type: 'SET_YEAR'; value: string }
  | { type: 'SET_MAKE'; value: string }
  | { type: 'SET_MODEL'; value: string }
  | { type: 'RESET_DEPENDENT_FIELDS'; field: 'year' | 'make' }
  | { type: 'UPDATE_FIELD_OPTIONS'; fieldName: string; options: YmmField['options'] }
  | { type: 'RESET_FIELDS' }
  | { type: 'SET_PRESERVE_FROM_RESTORE'; value: boolean }
  | { type: 'SET_APP_DISABLED'; value: boolean; message: string };

// Action Creators
export const ymmFormActions = {
  setLoading: (field: 'year' | 'make' | 'model', isLoading: boolean): YmmFormAction => ({
    type: 'SET_LOADING',
    field,
    isLoading,
  }),

  setError: (error: string | null): YmmFormAction => ({
    type: 'SET_ERROR',
    error,
  }),

  setFields: (fields: YmmField[]): YmmFormAction => ({
    type: 'SET_FIELDS',
    fields,
  }),

  setYear: (value: string): YmmFormAction => ({
    type: 'SET_YEAR',
    value,
  }),

  setMake: (value: string): YmmFormAction => ({
    type: 'SET_MAKE',
    value,
  }),

  setModel: (value: string): YmmFormAction => ({
    type: 'SET_MODEL',
    value,
  }),

  resetDependentFields: (field: 'year' | 'make'): YmmFormAction => ({
    type: 'RESET_DEPENDENT_FIELDS',
    field,
  }),

  updateFieldOptions: (fieldName: string, options: YmmField['options']): YmmFormAction => ({
    type: 'UPDATE_FIELD_OPTIONS',
    fieldName,
    options,
  }),

  resetFields: (): YmmFormAction => ({
    type: 'RESET_FIELDS',
  }),

  setPreserveFromRestore: (value: boolean): YmmFormAction => ({
    type: 'SET_PRESERVE_FROM_RESTORE',
    value,
  }),

  setAppDisabled: (value: boolean, message = ''): YmmFormAction => ({
    type: 'SET_APP_DISABLED',
    value,
    message,
  }),
};
